import { useParams } from 'react-router-dom'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import { MediumModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { BillingTypeSellOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell/billingTypeSellOption'
import useBillingDictTypes from '../../../../../../../../utils/hooks/billingGroups/useBillingDictTypes'


interface ModalCEConfigBillingTypeSellOptionProps extends ModalEditComponentProps { }

const ModalCEConfigBillingTypeSellOption: React.FC<ModalCEConfigBillingTypeSellOptionProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { BillingTypeSellId } = useParams()
    const { dictTypeBilling, dictExportType, dictRetentionType, dictVatSupportedType } = useBillingDictTypes()
    const fields: FormRender<BillingTypeSellOptionModelType > = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'typeBilling',
                    label: t('typeBilling', 'Tipo de Facturación'),
                    component: 'CustomSelect',
                    items: dictTypeBilling,
                    required: true
                },
                {
                    name: 'export',
                    label: t('export', 'Exportación'),
                    component: 'CustomSelect',
                    items: dictExportType,
                    required: true
                },
                {
                    name: 'retention',
                    label: t('retention', 'Retención'),
                    component: 'CustomSelect',
                    items: dictRetentionType,
                    required: true
                },
                {
                    name: 'withVat',
                    label: t('withVatSupported', 'Con IVA Soportado'),
                    component: 'CustomSelect',
                    items: dictVatSupportedType,
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                },
                {
                    name: 'BillingTypeSellId',
                    component: 'InputHidden',
                    value: BillingTypeSellId
                },

            ]
        }
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <MediumModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/billingTypeSell/option/updateBillingTypeSellOption'} translations={{ title: t('editBillingTypeSellOption', 'Editar Opción de Facturación de venta') + ' - ' + allRowData?.['name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/billingTypeSell/option/createBillingTypeSellOption'} translations={{
            title: t('createBillingTypeSellOption', 'Crear opción de facturación de venta'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCEConfigBillingTypeSellOption